import { REDUCERS } from '@/constants/reducers';

export function partidos(state, action) {
    switch (action.type) {
        case REDUCERS.UPDATE_PARTIDOS:
            return {
                ...state,
                partidos: action.payload,
            };
        default:
            return state;
    }
}
